<mat-radio-group class="categories" [value]="itemCategory" (change)="onSelectionChanged($event)">
  @for (itemCategory of itemCategories; track identifyItemCategory($index, itemCategory)) {
  <mat-radio-button class="category" [value]="itemCategory.category" [disabled]="itemCategory.count === 0">
    <span>{{ (itemCategory.category | itemCategoryLabel)?.label }}</span>
  </mat-radio-button>
  }
</mat-radio-group>
